import { Component, HostListener, ViewChild } from '@angular/core';
import { GenesysCloudService } from 'src/app/services/genesys-cloud.service';
import { GeneralServicesService } from './services/general-services.service';
import { LambdaServicesService } from './services/lambda-services.service';
import { SocketGenesysService } from './services/socket-genesys.service';
import { CdTimerComponent, CdTimerModule } from 'angular-cd-timer';
import { CallbackElement } from './interfaces/callbackElement';
import { saleElement } from './interfaces/saleElement';
import Swal from 'sweetalert2';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 's3-developer-genesys-cloud';
  data_user: any = {};
  result_socket_conversation: any;
  @ViewChild(CdTimerComponent) Timer: CdTimerComponent;
  private ENVIRONMENT = environment.ENVIRONMENT;
  telefono: any = '';
  cola: any = '';
  motivo_agendamiento: string = '';
  event_method = window.addEventListener ? "addEventListener" : "attachEvent";
  eventer = window[this.event_method];
  message_event = this.event_method === "attachEvent" ? "onmessage" : "message";
  conclution_code_selected: any = {};
  public presences: any = [];
  presence_select: any = '';
  routing_status: any = '';
  showQueues: boolean = false;
  showCallbacks: boolean = false;
  showCallCallbacks: boolean = false;
  callbackDay: any;
  callbackHour: any = {
    hour: 0,
    minute: 0
  };

  callBackArray: CallbackElement[] = [];
  dayShowCallbacks: any = {};
  searchingCallbacks: boolean = false;

  defaultTime = { hour: 12, minute: 0, second: 0 };

  callTime: any = "";
  callbackLoading: boolean = true;
  timeZone: string = "GMT-03:00";
  telefonoRellamada: any = "";
  // Teclado DTMF
  dtmfKeypad: string[][] = [
    ['1', '2', '3'],
    ['4', '5', '6'],
    ['7', '8', '9'],
    ['*', '0', '#']
  ];

  loadingSales: boolean = false;
  salesArray: any[] = [];


  constructor(
    public genesys_services: GenesysCloudService,
    public socket_services: SocketGenesysService,
    public lambda_services: LambdaServicesService,
    private general_services: GeneralServicesService,
  ) {
    //console.log('----------------------------------');
    //console.log('----------Cliente V2.1.0----------');
    //console.log('----------------------------------');
  }
  ngOnInit(): void {
    this.genesys_services.getWindowLocation()
      .then(result => {
        this.data_user = result;
        console.log(this.data_user);
        this.showRoutingStatus(this.data_user.routingStatus);
        this.getSocketConectionGenesys();
        this.genesys_services.subscribeToConversations()
          .then((result: any) => {
            //console.log(result);
            this.getPresences();
            this.result_socket_conversation = result;
            this.socket_services.createSocket(this.result_socket_conversation);
            this.socket_services.configWebRTC();
            this.socket_services.newMessageReceived().subscribe(data => {
              this.observador(data);
            });

          });
      });
    this.socket_services.currentMessage.subscribe(message => {
      this.changeTimer(message);
    });
    this.calcularHoraLlamada();
  }

  getDataUserGenesys() {
    this.genesys_services.getWindowLocation()
      .then(result => {
        this.data_user = result;
        //console.log(this.data_user);
        this.getSocketConectionGenesys();
      });
  }

  getSocketConectionGenesys() {
    this.genesys_services.subscribeToConversations()
      .then((result: any) => {
        //console.log(result);
        this.createSocketConversation(result);
      });
  }
  createSocketConversation(data) {
    this.socket_services.createSocket(data);
  }

  getPresences() {
    this.genesys_services.getPresences()
      .then((result: any) => {
        this.presences = result.entities;
        //console.log(this.presences);
        this.showPresence(this.data_user.presence.presenceDefinition.id);

      })
      .catch(error => {
        console.log(error);
      })
  }
  observador(event) {
    console.log(event.data, 'event-observador');
    if (event.data && event.data.eventBody && event.data.eventBody.message != "WebSocket Heartbeat") {
      //console.log('---------------------------------------------');
      //console.log(JSON.parse(event.data));
      //console.log('---------------------------------------------');
    }

    let eventData = JSON.parse(event.data);
    if (eventData.eventBody.message && eventData.eventBody.message.toLowerCase() != 'websocket heartbeat') {
      //console.log(eventData);
    }
    this.socket_services.isWSActive = true;

    //conversation message
    if (eventData.topicName == this.socket_services.topicConversations) {
      this.socket_services.setNewInteraction(eventData.eventBody);
    }
    else if (eventData.topicName == this.socket_services.topicPresence) {
      if (eventData.eventBody && eventData.eventBody.presenceDefinition) {
        //new Presence
        this.socket_services.currentPresence = eventData.eventBody.presenceDefinition;
        this.showPresence(this.socket_services.currentPresence.id);

      }
    } else if (eventData.topicName == this.socket_services.topicRoutingStatus) {
      if (eventData.eventBody && eventData.eventBody.routingStatus) {
        //new Routing Status
        this.socket_services.currentRoutingStatus = eventData.eventBody.routingStatus;
        this.showRoutingStatus(eventData.eventBody.routingStatus);
      }
    }
  }

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  //                                                Metodos para manejar HTML
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  showPresence(id_presence) {
    //console.log(id_presence);

    for (let index = 0; index < this.presences.length; index++) {
      const element = this.presences[index];
      if (element.id == id_presence) {
        //console.log(element);

        this.socket_services.currentPresence = element;
        this.presence_select = id_presence;
      }
    }
  }

  showRoutingStatus(element) {
    //console.log(element);
    this.socket_services.currentRoutingStatus = element;
    if (element.status == 'IDLE') {
      this.routing_status = 'ELEGIBLE A LLAMADOS';
    } else if (element.status == 'INTERACTING') {
      this.routing_status = 'INTERACTUANDO';
    } else {
      this.routing_status = 'NO ELEGIBLE';
    }
    //console.log(this.routing_status, 'showRoutingStatus');


  }

  answerCall(conversation) {
    //console.log(conversation, "conversation - answerCall");
    this.socket_services.answerCall(conversation);
  }

  cancelConsultTransfer() {
    this.socket_services.cancelConsultTransfer();
  }

  async consult() {
    let infoConversation = this.socket_services.conversations[this.socket_services.conversations.length - 1];
    //console.log(infoConversation);
    this.general_services.modalCargando();
    if (infoConversation &&
      infoConversation.currentCampaignLambda &&
      infoConversation.currentCampaignLambda.url_metadata &&
      infoConversation.currentCampaignLambda.url_metadata.queueTransferId &&
      infoConversation.currentCampaignLambda.url_metadata.campaignTransferId) {

      let paramsTransfer = {
        // "speakTo": "DESTINATION",
        // "destination": { "queueId": infoConversation.currentCampaignLambda.url_metadata.queueTransferId }
        "queueId": infoConversation.currentCampaignLambda.url_metadata.queueTransferId
      };


      // //console.log(params);
      // await this.genesys_services.setParticipantAtribute(infoConversation.id, infoConversation.customer.participantId, params);
      //console.log(infoConversation.currentCampaignLambda.url_metadata.queueTransferId);
      await this.socket_services.consult(infoConversation.id, infoConversation.agentParticipant.id, paramsTransfer);

      // await this.endCall(infoConversation);

      if (this.socket_services.conversations.length > 1) {
        await this.socket_services.setWrapupCode(infoConversation.id, infoConversation.agentParticipant.id, 'call-outbound', infoConversation.conversation.id, this.socket_services.id_cc_rellamada);
      }

      Swal.close();
    } else {
      this.general_services.modalErrorMensaje('Error', 'No se puede generar una transferencia a esta campaña.');
    }
  }

  llamarTelefono() {
    this.genesys_services.makeCall(this.telefono, this.cola)
      .then(result => {
        //console.log(result);
        this.socket_services.conversations[0].callActive = true;
      })
      .catch(error => {
        console.log(error);
      })
  }

  async Callback() {

    let array_skills = [];
    if (this.data_user.skills && this.data_user.skills[0].id) {
      array_skills = [this.data_user.skills[0].id];
    }

    await this.socket_services.generateCallback(null, array_skills, 'Llamar nuevamente.')
      .then(result => {
        //console.log(result, 'generateCallback-Callback');

        // this.socket_services.callBackPreference = '';
        this.socket_services.resetCallBackPreference();
        // this.general_services.modalMensaje('Llamada generada','La llamada le caerá pronto.');
      })
      .catch(error => {
        console.log(error);
        this.general_services.modalErrorMensaje('Error', 'Error en la generación de la llamada.');

      })
  }

  async reCall() {
    let array_skills = [];
    if (this.data_user.skills && this.data_user.skills[0].id) {
      array_skills = [this.data_user.skills[0].id];
    }
    try {
      // Si existe telefonoRellamada se envía, si no, se envía undefined
      const telefono = this.telefonoRellamada?.trim() || undefined;

      const result = await this.socket_services.generateCall(telefono).then(result => {
        //console.log(result, 'generateCall-Callback');

        // this.socket_services.callBackPreference = '';
        // this.socket_services.resetCallBackPreference();
        // this.general_services.modalMensaje('Llamada generada','La llamada le caerá pronto.');
      })
      // console.log(result);

    } catch (error) {
      console.log(error);
      this.general_services.modalErrorMensaje(
        'Error',
        'Error en la generación de la llamada.'
      );
    }
    this.telefonoRellamada = '';
  }


  async CallbackProgramado() {

    // Flag de campaña: deshabilitar callbacks previos del contacto al agendar.
    // Si no viene el valor, por defecto es false.
    const killPreviousCallbacks = this.socket_services.conversations[0]?.currentCampaignLambda?.url_metadata?.killPreviousCallbacks ?? false;
    console.log('killPreviousCallbacks (config campaña):', killPreviousCallbacks);

    let fecha_actual = new Date();
    let fecha_programada;
    //console.log(this.callbackHour, 'callbackHour-CallbackProgramado');

    try {

      //console.log(this.callbackHour.hour.toString(), 'hourString');
      //console.log(this.callbackHour.minute.toString(), 'minuteString');
      this.general_services.modalCargando();
      if (this.callbackHour.hour > 23 || this.callbackHour.hour < 0 || this.callbackHour.minute > 59 || this.callbackHour.minute < 0) {
        this.general_services.modalErrorMensaje("Fecha u Hora inválida", "Por favor reingresarlos");
        //console.log(this.callbackHour, 'error if-callbackHour-CallbackProgramado');
        return;
      }

      fecha_programada = new Date(this.callbackDay.year, (this.callbackDay.month - 1), this.callbackDay.day, this.callbackHour.hour, this.callbackHour.minute, 0, 0);
      //console.log('--------------Fecha uno---------------');
      //console.log(fecha_programada);
      //console.log(fecha_programada.toISOString());
      //console.log('--------------Fecha Dos---------------');

      let fecha_string = this.toMonthName(this.callbackDay.month) + ' ' + this.callbackDay.day + ", " + this.callbackDay.year + ' ' + this.numberToHH(this.callbackHour.hour) + ':' + this.numberToHH(this.callbackHour.minute) + ':00 GMT' + this.socket_services.getTimezone();
      // const event = new Date('August 30, 2022 15:50:30 GMT-03:00');
      console.log(fecha_string, 'fecha_string');

      fecha_programada = new Date(fecha_string);
      console.log(fecha_programada);
      //console.log(fecha_programada.toISOString());

    } catch (e) {
      this.general_services.modalErrorMensaje("Fecha u Hora inválida", "Por favor reingresarlos");
      console.log(e, 'error catch-callbackHour-CallbackProgramado');
      return;
    }
    let array_skills = [];
    if (this.socket_services.callBackPreference && this.socket_services.callBackPreference != '') {
      array_skills = [this.socket_services.callBackPreference];
    }


    if (fecha_programada.getTime() < fecha_actual.getTime()) {
      this.general_services.modalErrorMensaje("Fecha u Hora inválida", "Por favor ingrese una fecha superior a la actual.");
      return;
    }

    // Si la campaña lo indica, deshabilitar los callbacks activos del contacto
    // antes de crear el nuevo agendamiento.
    if (killPreviousCallbacks) {
      await this.socket_services.killActiveCallbacksForContact();
    }

    await this.socket_services.generateCallback(fecha_programada, array_skills, this.motivo_agendamiento)
      .then(result => {
        //console.log(result);
        // this.socket_services.callBackPreference = '';
        this.socket_services.resetCallBackPreference();
        this.motivo_agendamiento = '';
        this.general_services.modalMensaje({ titulo: 'Agendamiento generado', mensaje: 'El agendamiento se ha generado con éxito.' });
        this.callbackHour = {
          hour: 0,
          minute: 0
        };
      })
      .catch(error => {
        console.log(error);
        this.general_services.modalErrorMensaje('Error', 'Error en la generación de la llamada.');
      })

  }

  toMonthName(monthNumber) {
    const date = new Date();
    date.setMonth(monthNumber - 1);

    return date.toLocaleString('en-US', {
      month: 'long',
    });
  }
  numberToHH(number: number) {
    if (number < 10) {
      return '0' + number;
    }
    return number;
  }
  async endCall(conversation) {
    await this.socket_services.endCall(conversation);
  }

  async wrapupCode() {
    if (this.socket_services.wrapup_code_selected && this.socket_services.wrapup_code_selected != '') {
      await this.socket_services.wrapup();
    } else {
      this.general_services.modalErrorMensaje('Datos Faltantes', 'Por favor ingrese un código de conclusión.');
    }
  }

  async logout() {
    //console.log('Logout');

    this.socket_services.usuario_services.limpiarTokenStorage();
    this.socket_services.usuario_services.limpiarUsuarioStorage();


    let url = "https://login." + this.ENVIRONMENT + "/logout";
    window.location.replace(url);
  }

  clickConclutionCode(item) {
    this.conclution_code_selected = item;
    this.socket_services.wrapup_code_selected = item;
    //console.log(this.socket_services.wrapup_code_selected);
  }

  muteAudio(conversation) {
    let indexConversation = this.socket_services.indexArrayConversations(conversation.id);
    //console.log('Mute');
    this.socket_services.patchConversation(this.socket_services.conversations[indexConversation].id, this.socket_services.conversations[indexConversation].agent.participantId, { "muted": !this.socket_services.conversations[indexConversation].muted }, 'callbacks');
    this.socket_services.patchConversation(this.socket_services.conversations[indexConversation].id, this.socket_services.conversations[indexConversation].agent.participantId, { "muted": !this.socket_services.conversations[indexConversation].muted });
  }

  async skip(conversation: any) {
    await this.socket_services.patchConversation(conversation.id, conversation.agent.participantId, { "wrapup": { "code": "ININ-OUTBOUND-PREVIEW-SKIPPED", "notes": "", "tags": [] } });
    await this.endCall(conversation);
    this.socket_services.resetConversation();
  }

  heldAudio(conversation) {
    let indexConversation = this.socket_services.indexArrayConversations(conversation.id);
    //console.log('held');
    this.socket_services.patchConversation(this.socket_services.conversations[indexConversation].id, this.socket_services.conversations[indexConversation].agent.participantId, { "held": !this.socket_services.conversations[indexConversation].held }, 'callbacks');
    this.socket_services.patchConversation(this.socket_services.conversations[indexConversation].id, this.socket_services.conversations[indexConversation].agent.participantId, { "held": !this.socket_services.conversations[indexConversation].held });
  }

  changePresence() {
    //console.log(this.presence_select);
    if (this.presence_select) {
      this.genesys_services.updatePresence(this.presence_select)
        .then(result => {
          this.showPresence(this.presence_select);
          this.general_services.modalMensaje({ titulo: 'Estado cambiado', mensaje: "Estado del agente cambiado." });
        })
        .catch(error => {
          console.log(error);

          this.general_services.modalErrorMensaje("Error Estado", "Error al cambiar estado del agente.");
        });
    } else {
      this.general_services.modalErrorMensaje("Error Estado", "Por favor elija un estado válido.");
    }
  }

  makeEligibleForInteactions() {
    this.genesys_services.makeEligibleForInteactions()
  }

  clickDate(event) {
    this.callbackDay = event;
    //console.log(this.callbackDay);

  }

  clickDateCallbacks(event) {
    //console.log(event, 'event-clickDateCallbacks');
    this.dayShowCallbacks = event;
  }

  clickHour(event) {
    this.callbackHour = event;
    //console.log(this.callbackHour);

  }

  //////////////////////////////////////////Métodos Timer//////////////////////////////////////////
  changeTimer(message: any) {
    //console.log(message, 'message-changeTimer');

    if (message.pause) {
      this.pauseTimer();
    } else if (message.reset) {
      this.resetTimer();
    } else if (message.start) {
      this.startTimer();
    } else {
      //console.log('Sin accion al timer');
    }
  }
  async resetTimer() {
    if (this.Timer) {
      this.Timer.reset();
      return;
    } else {
      await this.sleep(1000);
      return this.resetTimer();
    }
  }

  async pauseTimer() {
    if (this.Timer) {
      this.Timer.stop();
      return;
    } else {
      await this.sleep(1000);
      return this.pauseTimer();
    }
  }

  async startTimer() {
    if (this.Timer) {
      this.Timer.start();
      return;
    } else {
      await this.sleep(1000);
      return this.startTimer();
    }
  }

  async calcularHoraLlamada() {
    while (true) {
      let len_conversations = this.socket_services.conversations.length;
      if (len_conversations == 0) {
        // //console.log('Sin conversacion activa');
        this.callTime = '0:00:00';
      } else if (this.socket_services.conversations[len_conversations - 1].id //Si terminó la conversación
        && this.socket_services.conversations[len_conversations - 1].agentParticipant
        && this.socket_services.conversations[len_conversations - 1].agentParticipant.calls
        && this.socket_services.conversations[len_conversations - 1].agentParticipant.calls[0].connectedTime
        && this.socket_services.conversations[len_conversations - 1].agentParticipant.calls[0].disconnectedTime) {

        let dateConnectedCall = new Date(this.socket_services.conversations[len_conversations - 1].agentParticipant.calls[0].connectedTime);
        let dateDisconnectedCall = new Date(this.socket_services.conversations[len_conversations - 1].agentParticipant.calls[0].disconnectedTime);
        let differencesTime = (dateDisconnectedCall.getTime() - dateConnectedCall.getTime()) / 1000;
        this.callTime = this.humanDiff(dateConnectedCall, dateDisconnectedCall);
      } else if (this.socket_services.conversations[len_conversations - 1].id //Si aún no termina la conversación
        && this.socket_services.conversations[len_conversations - 1].agentParticipant
        && this.socket_services.conversations[len_conversations - 1].agentParticipant.calls
        && this.socket_services.conversations[len_conversations - 1].agentParticipant.calls[0].connectedTime) {
        let dateConnectedCall = new Date(this.socket_services.conversations[len_conversations - 1].agentParticipant.calls[0].connectedTime);
        this.callTime = this.humanDiff(dateConnectedCall, new Date());
      } else { //Si es que aún no ha empezado la conversación
        this.callTime = '0:00:00';
      }
      await this.sleep(1000);
    }
  }

  humanDiff(t1, t2) {
    const diff = Math.max(t1, t2) - Math.min(t1, t2)
    const SEC = 1000, MIN = 60 * SEC, HRS = 60 * MIN

    const hrs = Math.floor(diff / HRS)
    const min = Math.floor((diff % HRS) / MIN).toLocaleString('en-US', { minimumIntegerDigits: 2 })
    const sec = Math.floor((diff % MIN) / SEC).toLocaleString('en-US', { minimumIntegerDigits: 2 })
    const ms = Math.floor(diff % SEC).toLocaleString('en-US', { minimumIntegerDigits: 4, useGrouping: false })

    return `${hrs}:${min}:${sec}`
  }


  sleep(ms = 0) {
    return new Promise(r => setTimeout(r, ms));
  }
  //////////////////////////////////////////Métodos Timer//////////////////////////////////////////

  showOrHideQueues() {
    this.showQueues = !this.showQueues;
  }

  setStateQueue(queue) {
    //console.log(queue, 'queue-setStateQueue');
    this.general_services.modalCargando();
    this.genesys_services.setStateQueue(queue.id, !queue.joined)
      .then(results => {
        this.genesys_services.getQueuesList(this.genesys_services.token.token, this.data_user.id)
          .then(results => {
            this.data_user.queues = results;
            //console.log(this.data_user, 'data_user-setStateQueue');
            this.general_services.modalMensaje({ titulo: 'Actualizado', mensaje: "El estado de la cola ha sido cambiado." });
          });
      })
      .catch(error => {
        this.general_services.modalErrorMensaje("Error cambio Cola", "Error al cambiar estado de la cola.");
      });
  }

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  //                                                Fin Metodos para manejar HTML
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  @HostListener("window:message", ["$event"]) onPostMessage(event: any) {
    // console.log("message from iframe", event);
    if (event.data.gestion_finished) {
      this.socket_services.conversations[0].formComplete = true;
    }
    if (event.data.sales_finished) {
      this.socket_services.conversations[0].saleFormComplete = true;
      this.socket_services.conversations[0].formComplete = true;
    }
  }

  areConversationsFinished() {
    let conversationsLength = this.socket_services.conversations.length;
    let conversationsAreFinished: boolean = true;
    try {
      if (conversationsLength == 0) {
        return false;
      } else {
        for (let index = 0; index < conversationsLength; index++) {
          const element = this.socket_services.conversations[index];
          if (element.state == 'disconnected' && !element.agentParticipant.calls) {
            //Corta sin llamar, por lo tanto si cuenta como interaccion terminada
          } else if (element.state != 'terminated') {
            conversationsAreFinished = false;
          }
        }
        return conversationsAreFinished;
      }
    } catch (e) {
      console.log(e, 'e-areConversationsFinished');
      return false;
    }
  }

  //////////////////////////////////////////////////////////////////////////////////////////////

  showOrHideCallbacks() {
    this.searchCallbacks();
    this.showCallbacks = !this.showCallbacks;
  }

  showOrHideCallCallbacks() {
    this.showCallCallbacks = !this.showCallCallbacks;
  }

  async searchCallbacks() {
    // //console.log(this.dayShowCallbacks, 'dayShowCallbacks-searchCallbacks');

    // if (!this.dayShowCallbacks || !this.dayShowCallbacks.day || !this.dayShowCallbacks.month || !this.dayShowCallbacks.year) {
    //   this.general_services.modalErrorMensaje('Error en fecha', 'Ingrese una fecha válida');
    //   return;
    // }

    // let date_number = this.dayShowCallbacks.year.toString() + this.numberToNN(this.dayShowCallbacks.month).toString() + this.numberToNN(this.dayShowCallbacks.day).toString();
    // //console.log(date_number, 'date_number-searchCallbacks');
    this.callbackLoading = true;
    this.callBackArray = [];
    this.lambda_services.postListCallback(
      // Number(date_number),
      this.data_user.id,
      this.data_user.skills && this.data_user.skills > 0 ? this.data_user.skills[0].id : null)
      .then((result: any) => {
        console.log(result, 'result-postListCallback');
        let array_callbacks: any = [];
        if (result.callbacks) {
          for (let index = 0; index < result.callbacks.length; index++) {
            let element = result.callbacks[index];
            element.metadata = JSON.parse(element.metadata);

            let elementCallback: CallbackElement = {
              type: element.metadata && element.metadata.tipo ? element.metadata.tipo : '.-',
              skill: element.metadata && element.metadata.skillId ? 'SI' : 'NO',
              date: element.metadata && element.metadata.dateString ? element.metadata.dateString : '.-',
              rut: element.metadata && element.metadata.rut ? element.metadata.rut.substring(0, 4) : '.-',
              name: element.metadata && element.metadata.name ? element.metadata.name : '.-',
              //name: 'Edison Contreras Ortiz.-',
              comment: element.metadata && element.metadata.observacion ? element.metadata.observacion : '.-',
              can_edit_callback: element.can_edit_callback ? element.can_edit_callback : false,
              conversationId: element.metadata && element.metadata.newConversationId ? element.metadata.newConversationId : null,
              callbackNumbers: element.metadata && element.metadata.callbackNumbers ? element.metadata.callbackNumbers : 
                               (element.callbackNumbers ? element.callbackNumbers : []),
              queueId: element.queueId ? element.queueId : null,
              skillIds: element.metadata && element.metadata.skillId ? [element.metadata.skillId] : [],
              metadata: element.metadata
            }
            array_callbacks.push(elementCallback);

          }
          this.callbackLoading = false;
          this.callBackArray = array_callbacks;
          //console.log(this.callBackArray, 'callBackArray-postListCallback');

        }
      })
      .catch(error => {
        console.log(error, 'error-postListCallback');
        this.general_services.modalErrorMensaje('Error en traer agendamientos', 'Intente nuevamente');
      })
  }

  numberToNN(number: number) {
    if (number < 10) {
      return '0' + number;
    }
    return number;
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  showOrHideSales() {
    this.loadingSales = true;
    this.searchSales();
  }
  searchSales() {
    this.salesArray = [];

    this.lambda_services.postListSales(this.data_user.id,)
      .then((result: any) => {
        //console.log(result, 'result-postListSales');
        let array_sales: any = [];
        if (result.sales) {
          for (let index = 0; index < result.sales.length; index++) {
            let element = result.sales[index];
            //console.log(element);

            let elementSales: saleElement = {
              cal_assig_id: element.cal_assig_id ? element.cal_assig_id : '.-',
              idinteraccion: element.idinteraccion ? element.idinteraccion : '.-',
              rut: element.rut ? element.rut.substring(0, 4) : '.-',
              nombre_cliente: element.nombre_cliente ? element.nombre_cliente : '.-',
              plan: element.plan ? element.plan : '.-',
              con_id: element.con_id ? element.con_id : '.-',
              estadoasignado: element.estadoasignado ? element.estadoasignado : '.-',
              fecha_venta: element.fecha_venta ? element.fecha_venta : '.-',
              estado_venta: element.estado_venta ? element.estado_venta : '.-',
              sponsor: element.sponsor ? element.sponsor : '.-',
            };

            array_sales.push(elementSales);

          }
          this.loadingSales = false;
          this.salesArray = array_sales;
          //console.log(this.salesArray, 'salesArray-postListSales');

        }
      })
      .catch(error => {
        console.log(error, 'error-postListSales');
        this.general_services.modalErrorMensaje('Error en traer agendamientos', 'Intente nuevamente');
      })

    // this.loadingSales = false;

  }

  // Método para enviar códigos DTMF (placeholder)
  sendDTMF(digit: string) {
    console.log('Enviando DTMF:', digit);
    // TODO: Implementar el servicio para enviar DTMF
  }

  async handleEditCallback(callback: CallbackElement) {
    console.log('Editando callback:', callback);
    
    if (!callback.can_edit_callback) {
      this.general_services.modalErrorMensaje('Sin permisos', 'No tienes permisos para editar este agendamiento');
      return;
    }

    if (!callback.conversationId) {
      this.general_services.modalErrorMensaje('Error', 'No se encontró el ID de conversación para este callback');
      console.error('conversationId no disponible:', callback);
      return;
    }

    // Obtener la fecha mínima (hoy) y máxima (30 días desde hoy)
    const today = new Date();
    const minDate = today.toISOString().split('T')[0];
    const maxDateObj = new Date(today);
    maxDateObj.setDate(maxDateObj.getDate() + 30);
    const maxDate = maxDateObj.toISOString().split('T')[0];

    // Mostrar un modal para seleccionar nueva fecha y hora
    const result = await Swal.fire({
      title: 'Reagendar Callback',
      html: `
        <div style="text-align: left;">
          <p><strong>Cliente:</strong> ${callback.name}</p>
          <p><strong>Fecha actual:</strong> ${callback.date}</p>
          <hr>
          <label for="swal-date">Nueva Fecha:</label>
          <input type="date" id="swal-date" class="swal2-input" style="width: 80%;" min="${minDate}" max="${maxDate}">
          <label for="swal-time">Nueva Hora:</label>
          <input type="time" id="swal-time" class="swal2-input" style="width: 80%;">
        </div>
      `,
      showCancelButton: true,
      confirmButtonText: 'Reagendar',
      cancelButtonText: 'Cancelar',
      preConfirm: () => {
        const date = (document.getElementById('swal-date') as HTMLInputElement).value;
        const time = (document.getElementById('swal-time') as HTMLInputElement).value;
        
        if (!date || !time) {
          Swal.showValidationMessage('Por favor ingrese fecha y hora');
          return false;
        }
        
        return { date, time };
      }
    });

    if (result.isConfirmed && result.value) {
      this.general_services.modalCargando();
      
      try {
        // Construir la fecha en el formato que espera generateCallback
        const newDateTime = new Date(`${result.value.date}T${result.value.time}:00`);
        const fecha_string = newDateTime.toLocaleString('en-US', { month: 'long' }) + ' ' + newDateTime.getDate() + ", " + newDateTime.getFullYear() + ' ' + this.numberToHH(newDateTime.getHours()) + ':' + this.numberToHH(newDateTime.getMinutes()) + ':00 GMT' + this.socket_services.getTimezone();
        const fecha_programada = new Date(fecha_string);
        
        // Validar que la fecha sea superior a la actual (misma lógica que CallbackProgramado)
        const fecha_actual = new Date();
        if (fecha_programada.getTime() < fecha_actual.getTime()) {
          Swal.close();
          this.general_services.modalErrorMensaje("Fecha u Hora inválida", "Por favor ingrese una fecha superior a la actual.");
          return;
        }
        
        // Validar que la fecha no sea mayor a 30 días
        const fecha_maxima = new Date(fecha_actual);
        fecha_maxima.setDate(fecha_maxima.getDate() + 30);
        if (fecha_programada.getTime() > fecha_maxima.getTime()) {
          Swal.close();
          this.general_services.modalErrorMensaje("Fecha u Hora inválida", "No puede reagendar más allá de 30 días.");
          return;
        }
        
        // 1. PRIMERO: Desactivar en Genesys Cloud
        let conversation: any = await this.genesys_services.getConversationDetails(callback.conversationId);
        console.log(conversation, 'conversa')
        if (conversation && conversation.participants) {
          let participant = conversation.participants.find((p: any) => p.purpose == "external" || p.purpose == "customer");
          
          if (participant && participant.sessions && participant.sessions.length == 1) {
            // Extraer datos del participante customer para usar en el nuevo callback
            let customerName = participant.participantName || participant.name || callback.name || '';
            // El teléfono está en sessions[0].callbackNumbers[0]
            let customerPhone = participant.sessions[0]?.callbackNumbers?.[0] || participant.address || callback.callbackNumbers?.[0] || '';
            
            // Obtener queueId desde la campaña usando dialerCampaignId
            let queueId = '';
            if (callback.metadata?.dialerCampaignId) {
              try {
                console.log('Obteniendo detalles de campaña:', callback.metadata.dialerCampaignId);
                //let campaign: any = await this.genesys_services.getCampaignDetails(callback.metadata.dialerCampaignId);
                queueId = callback.queueId;
                console.log('QueueId extraído de campaña:', queueId);
              } catch (error) {
                console.error('Error al obtener campaña, usando fallback:', error);
                // Fallback: intentar desde agentParticipant o callback
                let agentParticipant = conversation.participants.find((p: any) => p.purpose == "agent");
                queueId = agentParticipant?.queueId || callback.queueId || '';
              }
            } else {
              // Si no hay dialerCampaignId, usar el método anterior
              let agentParticipant = conversation.participants.find((p: any) => p.purpose == "agent");
              queueId = agentParticipant?.queueId || callback.queueId || '';
            }
            
            console.log('Datos extraídos de conversation.participants:', {
              customerName,
              customerPhone,
              queueId,
              participant,
              sessions: participant.sessions
            });
            
            // Matar el callback en Genesys
            await this.genesys_services.killCallback(
              callback.conversationId,
              participant.participantId,
              participant.sessions[0].sessionId
            );
            
            // 2. SEGUNDO: Si la desactivación en Genesys fue exitosa, actualizar en Lambda/BD
            await this.lambda_services.updateKillCallback(callback.conversationId);
            
            // 3. TERCERO: Guardar la metadata del callback eliminado para el reagendamiento
            // Construir la metadata del callback original para pasarla al nuevo
            const callbackMetadata = {
              dialerContactId: callback.metadata?.dialerContactId || '',
              dialerCampaignId: callback.metadata?.dialerCampaignId || '',
              dialerContactListId: callback.metadata?.dialerContactListId || '',
              sourceConverstionId: callback.metadata?.sourceConverstionId || '',
              userId: callback.metadata?.userId || '',
              rut: callback.rut || '',
              name: callback.name || '',
            };
            console.log(callback.metadata, 'metadata insert')
            // Guardar parámetros para createCallback usando datos de conversation.participants
            const callbackParams = {
              customerName: customerName,
              customerPhone: customerPhone,
              queueId: queueId,
            };
            
            console.log('Guardando metadata del callback para reagendamiento:', callbackMetadata);
            console.log('Guardando parámetros del callback para reagendamiento:', callbackParams);
            this.socket_services.pendingCallbackMetadata = callbackMetadata;
            this.socket_services.pendingCallbackParams = callbackParams;
            
            // 4. CUARTO: Crear nuevo callback usando el flujo existente
            // Usar los skills del callback original
            let array_skills = callback.skillIds && callback.skillIds.length > 0 ? callback.skillIds : [];
            

            console.log(array_skills, ' metadata para pasra insertar')
            // Generar el nuevo callback usando el método existente
            await this.socket_services.generateCallback(
              fecha_programada, 
              array_skills, 
              callback.metadata.observacion
            );
            
            Swal.close();
            const dateString = `${this.numberToNN(newDateTime.getDate())}/${this.numberToNN(newDateTime.getMonth() + 1)}/${newDateTime.getFullYear()} ${this.numberToHH(newDateTime.getHours())}:${this.numberToHH(newDateTime.getMinutes())}:00`;
            this.general_services.modalMensaje({ 
              titulo: 'Reagendamiento exitoso', 
              mensaje: `El callback ha sido reagendado para el ${dateString}` 
            });
            
            // Recargar la lista de callbacks
            this.searchCallbacks();
          } else {
            throw new Error('No se encontró un participante válido para cancelar el callback');
          }
        } else {
          throw new Error('No se pudo obtener la información de la conversación');
        }
        
      } catch (error) {
        console.log(error, 'error-handleEditCallback');
        Swal.close();
        this.general_services.modalErrorMensaje('Error', 'No se pudo reagendar el callback. Intente nuevamente.');
      }
    }
  }
}
